import { Route, Redirect } from "react-router-dom";

import { ROUTES } from "../constants/route";
import { useMyContext } from "../contexts/StateHolder";

const ProtectedRoute = ({ children, ...rest }) => {
	const { user } = useMyContext();
	const isLoggedIn = user?.userId > 0;

	return (
		<Route
			{...rest}
			render={({ location }) =>
				isLoggedIn ? (
					children
				) : (
					<Redirect
						to={{
							pathname: ROUTES.LOGIN,
							state: { from: location },
						}}
					/>
				)
			}
		/>
	);
};

export default ProtectedRoute;
